<template>
  <div class="vuse-content-wrapper">
    <vuse-section-definition
        :breadcrumbs="breadcrumbs"
        :title="page"
        icon="mdi-image-filter-hdr"
    ></vuse-section-definition>
    <v-container fluid>
      <v-row class="mx-1 mt-2">
        <v-col cols="8" class="white p-5 ">
          <v-col cols="12">
            <div class="mb-2 primary--text">Name<span class="necessary">(*)</span></div>
            <v-text-field
                v-model="bundle.name"
                placeholder="Enter name"
                filled
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <div class="mb-2 primary--text">Templates<span class="necessary">(*)</span></div>
            <v-select
                v-model="list_templates_id"
                :items="list_templates"
                item-text="name"
                item-value="id"
                filled
                placeholder="Choose template"
                chips
                multiple
            ></v-select>
          </v-col>
          <v-col cols="12">
            <div class="mb-2 primary--text">Credit<span class="necessary">(*)</span></div>
            <v-text-field
                v-model="bundle.credit"
                placeholder="Enter credit"
                filled
            ></v-text-field>
          </v-col>
          <v-col cols="12">
            <div class="mb-2 primary--text">Description<span class="necessary">(*)</span></div>
            <v-text-field
                v-model="bundle.description"
                placeholder="Enter description"
                filled
            ></v-text-field>
          </v-col>

          <v-col cols="12">
            <div class="mb-2 primary--text">Upload image<span class="necessary">(*)</span></div>
            <v-file-input
                filled
                prepend-icon="mdi-camera"
                v-model="bundle.img_url"
                @change="uploadImg"
            ></v-file-input>
            <div v-if="src" class="mb-5">
              <v-img
                  :src="src"
                  aspect-ratio="1.7"
                  contain
                  class="mx-auto"
              ></v-img>
            </div>
          </v-col>
          <v-col cols="12" class="text-center mb-5 mt-1">
            <v-btn
                class="btn-add-templates"
                @click="save"
            >
              Add Bundle
            </v-btn>
          </v-col>
        </v-col>

      </v-row>
    </v-container>
  </div>
</template>

<script>
import {SAVE_BUNDLE} from "@/store/modules/bundle";
import {mapGetters} from "vuex";
import {GET_LIST_TEMPLATE} from "@/store/modules/template";

export default {
  name: "AddBundle",
  data() {
    return {
      page: "Add Bundle",
      breadcrumbs: [
        {
          text: "Templates Setting",
          disabled: true,
        },
        {
          text: "Bundle",
          disabled: false,
          href: '/template_setting/bundle',
        },
        {
          text: "Add Bundle",
          disabled: false,
        },
      ],
      bundle: {
        name: '',
        credit: '',
        description: '',
        img_url: null,
        templates: []
      },
      src: '',
      pattern: /\D/g,
      list_templates: [],
      list_templates_id: [],
    }
  },
  computed: {
    ...mapGetters({
      templates: "templates",
    })
  },
  async created() {
    await this.$store.dispatch(GET_LIST_TEMPLATE);
  },
  watch: {
    templates(val) {
      if (val) {
        const _this = this
        val.forEach(el => {
          _this.list_templates.push({
            id: el.id,
            name: el.name,
          })
        })
      }
    },
  },
  methods: {
    uploadImg(e) {
      if (e) {
        this.src = URL.createObjectURL(e)
      }
      this.$forceUpdate()
    },
    async save() {
      if (this.bundle.name == '') {
        alert('Name is empty');
      } else if (this.list_templates_id.length == 0) {
        alert("List template is empty")
      } else if (this.bundle.credit == '') {
        alert('Credit is empty');
      } else if (this.bundle.credit.match(this.pattern)) {
        alert("Credit must be digits!");
      } else if (this.bundle.description == '') {
        alert('Description is empty');
      } else if (this.bundle.img_url == null) {
        alert('Image is empty');
      } else {
        const _this = this
        this.list_templates_id.forEach(id => {
          let tag = this.list_templates.find(el => el.id == id)
          _this.bundle.templates.push(tag.id
          )
        })
        let form = new FormData();
        form.append("name", this.bundle.name);
        form.append("credit", this.bundle.credit);
        form.append("description", this.bundle.description);
        form.append("templates", JSON.stringify(this.bundle.templates));
        form.append("upload", this.bundle.img_url);
        await this.$store.dispatch(`${SAVE_BUNDLE}`, form).then((data) => {
              if (data.data.status == 1) {
                this.$toasted.success('Update successful!', {
                  duration: 1000,
                  position: 'top-center'
                })
                this.$router.push('/template_setting/bundle')
              } else {
                alert(data.data.errors)
              }
            }
        )
        ;
      }

    }
  }
}
</script>

<style scoped>
.btn-add-templates {
  background-color: #71BEC8 !important;
  color: white !important;
  border-radius: 36px !important;
}
.necessary {
  color: red;
}

</style>